import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';
import { PatchDisplaySettingsRequestBody } from '@/api/apis/route';
import { deviceTrackingQueryKeys } from './device-tracking.keys';

type DeviceTrackingDisplaySettingsMutationPayload = {
  deviceTrackingId: string;
  caseId: string;
  data: PatchDisplaySettingsRequestBody;
};

export const useDeviceTrackingDisplaySettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ deviceTrackingId, data }: DeviceTrackingDisplaySettingsMutationPayload) =>
      api.route.patchDeviceTrackingDisplaySettings(deviceTrackingId, data),
    onSuccess: (_res, { deviceTrackingId, caseId }) => {
      queryClient.invalidateQueries({ queryKey: deviceTrackingQueryKeys.getItem(deviceTrackingId) });
      queryClient.invalidateQueries({ queryKey: deviceTrackingQueryKeys.getByCaseId(caseId) });
    },
  });
};
